import { Box, IconButton } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";

export default function ToolBar(props) {
  return (
    <Box
      sx={{
        display: "flex",
        marginTop: "10px",
      }}
    >
      {props.showViwModeButtons && (
        <>
          <Box
            sx={{
              border: "solid 1px #c8c8c85c",
              padding: "2px",
              borderRadius: "2px",
              textWrap: "nowrap",
              position: "fixed",
              zIndex: "999",
            }}
          >
            <>
              <IconButton size="small" onClick={() => props.handleToggleCSVSettings()}>
                <SettingsIcon fontSize="inherit" />
              </IconButton>
            </>
          </Box>
        </>
      )}
      <span
        style={{
          marginLeft: "80px",
        }}
      />

      {props.children}
    </Box>
  );
}
